
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 490 490"}},[_c('path',{attrs:{"d":"M480 15H10C4.477 15 0 19.477 0 25v40c0 5.523 4.477 10 10 10h10v290c0 5.523 4.478 10 10 10h205v80h-20v20h60v-20h-20v-80h205c5.522 0 10-4.477 10-10V75h10c5.522 0 10-4.477 10-10V25c0-5.523-4.478-10-10-10zm-30 340H40V75h410v280zm20-300H20V35h450v20z"}}),_c('path',{attrs:{"d":"M70 115h60v20H70zM70 155h170v20H70zM70 205h350v20H70zM70 245h350v20H70zM70 285h260v20H70zM380 285h40v20h-40zM395 100h30v20h-30zM350 100h30v20h-30zM395 130h30v20h-30z"}})])
      }
    
      }
    